export const getYearOptions = () => {
  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()
  const currentMonth = currentDate.getMonth() + 1 // getMonth() returns 0-11

  // If November (month 11), include next year, otherwise start from current year
  const latestYear = currentMonth === 11 ? currentYear + 1 : currentYear

  return Array.from({ length: 5 }, (_, i) => latestYear - i)
}

export const lastN = (value: string | number, n: number) => {
  const valueAsString = String(value ?? '')
  if (!valueAsString) return ''
  return valueAsString.length <= n ? valueAsString : valueAsString.slice(-n)
}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/**
 * Delimiter used to split a single string of email addresses into an array.
 *
 * The Bulk Upload preview and the backend `ClientBillingProfileService.processRow`
 * must agree on how a cell like `a@b.com, c@d.com` is parsed, so this regex is the
 * single source of truth for splitting email lists in this feature.
 */
export const EMAIL_DELIMITER_REGEX = /[;,]/

export const isValidEmail = (value: string) => EMAIL_REGEX.test(value)

export const validateEmailList = (_: unknown, value: string[]) => {
  const invalid = (value ?? []).filter((v) => !isValidEmail(v))
  if (invalid.length === 0) return Promise.resolve()
  return Promise.reject(
    new Error(
      `Invalid email address${invalid.length > 1 ? 'es' : ''}: ${invalid.join(', ')}`
    )
  )
}
